import { render, staticRenderFns } from "./WechatBindUser.vue?vue&type=template&id=dea5fbd6&"
import script from "./WechatBindUser.vue?vue&type=script&lang=js&"
export * from "./WechatBindUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports